import { ConfirmationDialog } from 'components/ConfirmationDialog';
import { DropdownContext } from 'components/DropdownContext';
import type { IDropdownContextProps } from 'components/DropdownContext';
import { ProjectStatusEnum } from 'gql/graphql';
import { useAccess } from 'hooks/useAccess';
import { useHandleEditProject } from 'hooks/useHandlersProject';
import { useMethodsProjectDelete } from 'hooks/useMethodsProjectDelete';

import { useMemo } from 'react';

import { ErrorHandlingModal } from '../ErrorHandlingModal';

interface IKebabTreeProject extends Partial<IDropdownContextProps> {
    projectRules: Record<string, boolean>;
    statusProject: ProjectStatusEnum | undefined;
    isAvailableWorkOrder?: boolean;
    projectId?: string;
    methodology?: string;
}

export const KebabTreeProject = ({
    projectId,
    methodology,
    projectRules,
    statusProject,
    isAvailableWorkOrder,
    ...propsDropdown
}: IKebabTreeProject) => {
    const {
        isConfirmationDialogOpen,
        handleCloseDeleteDialog,
        closeErrorModalHandler,
        deleteData,
        deleteStatus,
        deleteError,
        handleDeleteExactly,
        handleDeleteBtn,
        isErrorDialogOpen,
        handleCreateReportDownload,
    } = useMethodsProjectDelete(projectId);

    const handleEditProject = useHandleEditProject(projectId, methodology);
    const { contract: contractRules } = useAccess();

    const isProjectStatusDelayed = statusProject === ProjectStatusEnum.Delayed;
    const isProjectStatusCompleted = statusProject === ProjectStatusEnum.Completed;

    const isDisableEditProject = !projectRules.canEdit;
    const isDisableDeleteBtn =
        isProjectStatusDelayed || isProjectStatusCompleted || !projectRules.canDelete || isAvailableWorkOrder;

    const actions = useMemo(
        () => [
            {
                label: 'Редактировать',
                action: handleEditProject,
                disabled: isDisableEditProject,
            },
            {
                label: 'Удалить проект',
                action: handleDeleteBtn,
                disabled: isDisableDeleteBtn,
            },
        ],
        [handleDeleteBtn, handleEditProject, isDisableDeleteBtn, isDisableEditProject],
    );

    if (!projectId) {
        return null;
    }

    const disabledDropdown = !contractRules?.canEdit && !contractRules?.canDelete;

    return (
        <>
            <DropdownContext isDisabled={disabledDropdown} items={actions} {...propsDropdown} />
            <ConfirmationDialog
                textHeader="УДАЛЕНИЕ ПРОЕКТА"
                textConfirmation="Вы уверены, что хотите удалить текущий проект?"
                cancelButtonText="Не удалять"
                confirmButtonText="Удалить"
                isOpened={isConfirmationDialogOpen}
                onSubmit={handleDeleteExactly}
                onClose={handleCloseDeleteDialog}
            />
            <ErrorHandlingModal
                titleText="УДАЛЕНИЕ ПРОЕКТА"
                isSubmitted={isErrorDialogOpen}
                statusRequest={deleteStatus}
                dataRequest={deleteData?.deleteProject}
                errorsRequest={deleteError}
                handleCloseModalError={closeErrorModalHandler}
                handleCreateReport={handleCreateReportDownload}
            />
        </>
    );
};

KebabTreeProject.displayName = 'KebabTreeProject';
